import { NewAddressFormBaseComponent } from './../../standalone-components/new-address-form/new-addres-form-base';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { LocalizePipe } from '../../localize/localize.pipe';
import { TranslateModule } from '@ngx-translate/core';
import { NgSelectModule } from '@ng-select/ng-select';
import { AddressFormComponent } from './address-form/address-form.component';
import { ErrorComponent } from '../shared/error/error.component';

@NgModule({
	declarations: [
		AddressFormComponent
	],
	imports: [
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		RouterModule,
		LocalizePipe,
		TranslateModule,
		NgSelectModule,
		NewAddressFormBaseComponent,
		ErrorComponent
	],
	exports: [
		AddressFormComponent
	],
})
export class GeoModule { }
